
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member/redeem",
      function () {
        return require("private-next-pages/member/redeem/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member/redeem"])
      });
    }
  